<template>
  <div class="chart-reports" v-if="graphDisplay">
    <div class="chart-reports-top">
      <div class="chart-top-left">
        <div class="chart-video-img">
          <img
            :src="graphDisplay.thumbnail"
            alt="video thumbnail"
            ref="image"
          />
        </div>
        <div class="chart-video-title">
          <h2>{{ graphDisplay.title }}</h2>
        </div>
      </div>
      <div class="chart-top-right">
        <div class="reports-date-input">
          <form>
            <div class="reports-date-group">
              <div class="reports-form-date">
                <label>FROM</label>
                <div class="reports-date-input">
                  <b-form-datepicker
                    placeholder="Add Date"
                    :date-format-options="dateFormatOption"
                    class="form-control notranslate"
                    :id="'fromDate'+graphDisplay.graphId"
                    type="date"
                    :min="new Date(graphDisplay.minFromDate)"
                    :max="maxFromDate"
                    v-model="fromDate"
                  >
                  </b-form-datepicker>
                </div>
              </div>
              <div class="reports-to-date">
                <label>TO</label>
                <div class="reports-date-input">
                  <b-form-datepicker
                    placeholder="Add Date"
                    :date-format-options="dateFormatOption"
                    :min="minToDate"
                    :max="new Date(graphDisplay.maxToDate)"
                    class="form-control notranslate"
                    :id="'toDate'+graphDisplay.graphId"
                    type="date"
                    v-model="toDate"
                  >
                  </b-form-datepicker>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="chart-reports-body">
      <div class="chart-reports-item">
        <div class="chart-reports-title">
          <h2>Average Accuracy Score</h2>
        </div>
        <div class="chart-reports-div" :key="fromDate + toDate">
          <bar-chart
            :chart-data="graphDisplay.firstGraph"
            :options="optionsBar"
            @bar-clicked="onBarClicked"
            :graphId="graphDisplay.graphId"
            :height="200"
          />
        </div>
      </div>
      <div class="chart-reports-item">
        <div class="chart-reports-title">
          <h2>Effective Workout Duration</h2>
        </div>
        <div class="chart-reports-div" :key="fromDate + toDate">
          <bar-chart
            :chart-data="graphDisplay.secondGraph"
            :options="optionsBar"
            @bar-clicked="onBarClicked"
            :graphId="graphDisplay.graphId"
            :height="200"
          />
        </div>
      </div>
      <div class="chart-reports-item" v-if="!disableCalories">
        <div class="chart-reports-title">
          <h2>Calories Burned</h2>
        </div>
        <div class="chart-reports-div" :key="fromDate + toDate">
          <bar-chart
            :chart-data="graphDisplay.ThirdGraph"
            :options="optionsBar"
            @bar-clicked="onBarClicked"
            :graphId="graphDisplay.graphId"
            :height="200"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "@/module_user/components/BarChart";
import moment from "moment";
import { createNamespacedHelpers } from "vuex";

const { mapState: layoutState } = createNamespacedHelpers("dashboard/layout");

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      dateFormatOption: { year: "numeric", month: "short", day: "2-digit" },
      maxFromDate: "",
      minToDate: "",
      optionsBar: {
        legend: false,
        title: {
          display: false,
          text: "",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontColor: "#white",
                showLabelBackdrop: false,
              },
            },
          ],
        },
      },
      fromDate: "",
      toDate: "",
      graphDisplay: null,
    };
  },
  props: {
    data: {
      type: Object,
    },
  },
  methods: {
    onBarClicked(index) {
      this.$router.push(
        `/management/playback/${
          this.setReportsGraphDataState[index.graphId - 1]
            .UserExerciseHistories[0].sessionId
        }`
      );
    },
    updateGraphData(fromDate, toDate) {
      const keys = ["firstGraph", "secondGraph", "ThirdGraph"];
      let firstDataPointIndex = 0,
        lastDataPointIndex = this.data.firstGraph.labels.length;
      if (fromDate) {
        firstDataPointIndex = this.data.firstGraph.labels.findIndex((label) => {
          return moment(label).isSameOrAfter(fromDate);
        });
      }

      if (toDate) {
        lastDataPointIndex = this.data.firstGraph.labels.findIndex((label) => {
          return !moment(label).isSameOrBefore(toDate);
        });
        if (lastDataPointIndex == -1) {
          lastDataPointIndex = this.data.firstGraph.labels.length;
        }
      }
      console.log(fromDate, toDate, firstDataPointIndex, lastDataPointIndex)
      for (const key of keys) {
        this.graphDisplay[key].labels = this.data[key].labels.slice(
          firstDataPointIndex,
          lastDataPointIndex
        );

        this.graphDisplay[key].datasets[0].data = this.data[
          key
        ].datasets[0].data.slice(firstDataPointIndex, lastDataPointIndex);

        this.graphDisplay[key].datasets[0].backgroundColor = this.data[
          key
        ].datasets[0].backgroundColor.slice(
          firstDataPointIndex,
          lastDataPointIndex
        );
      }
    },
  },
  computed: {
    ...layoutState(["setReportsGraphDataState"]),
    disableCalories() {
      return (
        this.$store?.state?.userInfo?.corporate?.config?.disableCalories ??
        false
      );
    },
  },
  mounted() {
    const vm = this;
    this.$nextTick(() => {
      vm.graphDisplay = JSON.parse(JSON.stringify(vm.data));
      vm.fromDate = vm.data.minFromDate.startOf('day').toDate();
      vm.toDate = vm.data.maxToDate.endOf('day').toDate();
    });
  },
  watch: {
    fromDate: function(val) {
      this.minToDate = new Date(val);
      this.updateGraphData(val, this.toDate);
    },
    toDate: function(val) {
      this.maxFromDate = new Date(val);
      this.updateGraphData(this.fromDate, val);
    },
  },
};
</script>

<style scoped lang="scss">
.reports-date-input .reports-date-group {
  display: flex;
  flex-wrap: wrap;
}

.reports-date-group label {
  color: #73bc44;
  font-size: 12px;
  font-family: Poppins;
  font-weight: 700;
  margin: 0;
  padding-bottom: 4px;
}

.reports-form-date {
  margin-right: 17px;
}

.reports-date-input {
  position: relative;
}

.reports-date-input img {
  position: absolute;
  top: 7px;
  left: 8px;
}

.reports-date-input .form-control {
  border-radius: 5px;
  border: 2px solid #969b92;
  background: #fff;
  padding: 8px 12px;
  font-size: 12px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 1;
  color: #73bc44;
  padding-left: 30px;
}

.reports-date-input .form-control::placeholder {
  color: #73bc44;
}

.reports-form-date,
.reports-to-date {
  margin-bottom: 20px;
}

.reports-date-bottom ul {
  padding-left: 0;
  display: flex;
  align-items: center;
}

.reports-date-bottom li {
  list-style: none;
  margin-right: 16px;
}

.reports-date-bottom li a {
  color: #73bc44;
  font-size: 12px;
  font-family: Poppins;
  font-weight: 700;
  line-height: 16px;
}

.reports-date-bottom li .form-check-label {
  color: #969b92;
  font-size: 12px;
  font-family: Poppins;
  font-weight: 500;
}

.reports-date-bottom li .form-check-input {
  width: 17px;
  height: 17px;
  border-color: #73bc44;
}

.reports-date-bottom li .form-check-label span {
  padding-left: 10px;
}

.chart-reports {
  background-color: #eeeeee;
  padding: 20px;
}

.chart-reports-top {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.chart-top-left {
  display: flex;
  align-items: center;
  flex: 1;
}

.chart-video-img {
  width: 131px;
  height: 74px;
}

.chart-video-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

.chart-video-title {
  padding-left: 15px;
}

.chart-video-title h2 {
  color: #141513;
  font-size: 20px;
  font-weight: 700;
  line-height: normal;
  line-height: 24px;
}

.chart-reports-item {
  padding: 20px 0;
}

.chart-reports-title h2 {
  color: #141513;
  font-size: 20px;
  line-height: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.chart-reports-div {
  padding: 15px;
  background-color: #fff;
}

.reports-date-input .reports-date-group {
  display: flex;
  flex-wrap: wrap;
}

@media screen and (max-width: 768px) {
  .reports-date-group {
    flex-direction: column;
    .reports-form-date {
      margin-right: 0;
    }
  }

  .chart-reports-top {
    justify-content: center;
    .chart-top-left {
      width: 100%;
      padding-bottom: 1rem;
    }
    .chart-top-right {
      width: 100%;
    }
  }

  .chart-video-img {
    width: auto;
    height: auto;
    max-width: 8.25rem;
  }
}
</style>
